export const ENVIRONMENT = process.env.REACT_APP_ENV ?? ''

export const PRODUCT_API_URL = process.env.REACT_APP_PRODUCT_API_URL ?? ''
export const ACCOUNT_API_URL = process.env.REACT_APP_ACCOUNT_API_URL ?? ''
export const FREIGHT_API_URL = process.env.REACT_APP_FREIGHT_API_URL ?? ''

export const SHELL_PUBLIC_URL = process.env.REACT_APP_SHELL_PUBLIC_URL ?? ''
export const REPORT_PUBLIC_URL = process.env.REACT_APP_REPORT_PUBLIC_URL ?? ''
export const DELIVERY_PUBLIC_URL = process.env.REACT_APP_DELIVERY_PUBLIC_URL ?? ''

export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM ?? ''
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? ''
export const KEYCLOAK_URL = process.env.REACT_APP_KEYCLOAK_URL ?? ''
export const KEYCLOAK_REDIRECT_URL_LOGOUT = process.env.REACT_APP_KEYCLOAK_REDIRECT_URL_LOGOUT ?? ''

export const CONFIG_ALERTS_LIMIT_DISPLAY_LIST =
  process.env.REACT_APP_CONFIG_ALERTS_LIMIT_DISPLAY_LIST ?? ''

export const CONFIG_TIMELINE_PURGE_DAYS = process.env.REACT_APP_CONFIG_TIMELINE_PURGE_DAYS ?? 0

export const FLAG_ENABLE_REDIRECT_SHELL = process.env.REACT_APP_FLAG_ENABLE_REDIRECT_SHELL ?? ''

export const FLAG_LIGHT_VERSION_CARD_VIEW = process.env.REACT_APP_FLAG_LIGHT_VERSION_CARD_VIEW ?? ''

export const FLAG_LIGHT_VERSION_SORT_FILTER =
  process.env.REACT_APP_FLAG_LIGHT_VERSION_SORT_FILTER ?? ''

export const FLAG_LIGHT_VERSION_GROUP_VARIATIONS =
  process.env.REACT_APP_FLAG_LIGHT_VERSION_GROUP_VARIATIONS ?? ''

export const FLAG_LIGHT_VERSION_STATUS_TIMELINE_ALL =
  process.env.REACT_APP_FLAG_LIGHT_VERSION_STATUS_TIMELINE_ALL ?? ''

export const FLAG_ENABLE_SERVER_MOCK = process.env.REACT_APP_FLAG_ENABLE_SERVER_MOCK ?? ''

export const FLAG_VALIDATE_API_SELLERS = process.env.REACT_APP_FLAG_VALIDATE_API_SELLERS ?? ''

export const FLAG_ENABLE_MOCK_PERMISSION = process.env.REACT_APP_FLAG_ENABLE_MOCK_PERMISSION ?? ''

export const NETSHOES_CHANNEL_ID = process.env.REACT_APP_NETSHOES_CHANNEL_ID ?? ''

export const NETSHOES_REDIRECT_LIST_URL = process.env.REACT_APP_NETSHOES_REDIRECT_LIST_URL ?? ''
export const ELASTIC_API_URL = process.env.REACT_APP_ELASTIC_API_URL ?? ''

export const ENABLE_ELASTIC = process.env.REACT_APP_ENABLE_ELASTIC ?? ''

export const CONFIG_ABLE_SELLERS_FOR_PRODUCT_PERFORMANCE =
  process.env.REACT_APP_CONFIG_ABLE_SELLERS_FOR_PRODUCT_PERFORMANCE ?? ''
